// extracted by mini-css-extract-plugin
module.exports = {"drawer":"_c4f4e1","title":"_0b30aa","fadeDivider":"_ed742b","section":"_21c5f0","link":"_2de0a5","divider":"_0d82ec","paperProps":"_446389","fade":"_56b7fe"};